var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-page"},[_c('header-back',{attrs:{"title":_vm.title},on:{"back":_vm.onClickBack}}),(!_vm.loading)?_c('my-form',{attrs:{"data":_vm.baseFormData}}):_c('cube-loading',{attrs:{"size":24}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }